module.exports = __webpack_public_path__ + "static/assets/3c8f1fdb57481913036cb3581e84bc72.png";